import { QrCodeEndpoint } from "@/views/loyalty/shared/endpoint_services/qrcode-endpoint-service"

export class QrCodeService {
    constructor () {
        this.qrcodeEndpoint = new QrCodeEndpoint()
    }

    async getQrCode (item) {
        return this.qrcodeEndpoint.get_qrcode(item)
    }
}
